﻿window.isue_silencezones = function () {
    var instance = {
        init: function (args) {
            var table = document.getElementById(args.clientID);
            table.querySelectorAll("td[r][c]").forEach(el => {
                el.addEventListener("mousedown", function (evt) {
                    document.getElementById(args.clientID + '_contenttoolbar').querySelectorAll('a.disabled').forEach(el => {
                        el.classList.remove('disabled');
                    });
                    document.getElementById(args.clientID + '_contenttoolbar').querySelectorAll('a').forEach(el => {
                        el.setAttribute("data-p-_returnparent", "False");
                    });
                });
            });
        }
    };
    return instance;
}();